export default __webpack_public_path__ + "static/media/SmartwatchR.4eb1a9a1.jpg";